import React from "react";
import { OnyxMascotFace } from "../../shared/OnyxMascot";
import { useI18n } from "../i18n";

export function Footer() {
  const { t } = useI18n();

  return (
    <footer className="border-t border-[#2a2040] pt-16 pb-8 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-12">
          {/* Brand column */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <OnyxMascotFace size={28} />
              <span className="text-lg font-semibold text-white onyx-title">
                ONYX <span className="text-[#c0a0e0] font-normal text-sm">AI</span>
              </span>
            </div>
            <p className="text-sm text-[#8a7a9a] leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Product links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">{t("footer.product")}</h3>
            <ul className="space-y-2.5">
              <li><a href="/features/" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("nav.features")}</a></li>
              <li><a href="/pricing/" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("nav.pricing")}</a></li>
              <li><a href="/docs" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("footer.docs")}</a></li>
            </ul>
          </div>

          {/* Company links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">{t("footer.company")}</h3>
            <ul className="space-y-2.5">
              <li><a href="/about" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("footer.about")}</a></li>
              <li><a href="/blog" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("footer.blog")}</a></li>
              <li><a href="/affiliate" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("affiliate.badge")}</a></li>
              <li><a href="/privacy" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("footer.privacy")}</a></li>
              <li><a href="/terms" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("footer.terms")}</a></li>
            </ul>
          </div>

          {/* Solutions links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">Solutions</h3>
            <ul className="space-y-2.5">
              <li><a href="/solutions/ecommerce" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">E-Commerce</a></li>
              <li><a href="/solutions/restaurants" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">Restaurants</a></li>
              <li><a href="/solutions/healthcare" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">Healthcare</a></li>
              <li><a href="/solutions/education" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">Education</a></li>
            </ul>
          </div>

          {/* Support links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4">{t("footer.support")}</h3>
            <ul className="space-y-2.5">
              <li><a href="mailto:hello.onyx@cloudforge.com.my" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("footer.contact")}</a></li>
              <li><a href="/status" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("footer.status")}</a></li>
              <li><a href="/docs" className="text-sm text-[#8a7a9a] hover:text-[#c0a0e0] transition-colors">{t("footer.docs")}</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#2a2040] pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-sm text-[#8a7a9a]">
            &copy; {new Date().getFullYear()} Cloudforge Studio. {t("footer.rights")}
          </p>
          <div className="flex items-center gap-2">
            <OnyxMascotFace size={20} />
            <span className="text-xs text-[#8a7a9a]">
              Onyx AI by Cloudforge Studio
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
